import { SKELETON_TOKENS, skeletonPulse } from '@/theme/skeletonTokens';

// ----------------------------------------------------------------------

// 새로 쓰는 <Skeleton> 이 prop 없이도 가이드 모양으로 나오게 하는 게 목적
export default function Skeleton() {
  return {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: SKELETON_TOKENS.color,
          borderRadius: SKELETON_TOKENS.radius,
          ...skeletonPulse,
        },
        // MUI text 변형의 scale(1, .6) 축소 해제 — 지정한 height 가 그대로 보이게
        text: {
          transform: 'none',
          borderRadius: SKELETON_TOKENS.radius,
        },
        // width 기본값이 100% 라, 가로 flex 안에서 형제와 겹치면 컨테이너를 넘음.
        // 마진이 붙은 경우도 마찬가지(마진은 100% 에 안 포함됨) — 넘치는 대신 줄어들게 함
        rectangular: {
          borderRadius: SKELETON_TOKENS.radius,
          maxWidth: '100%',
        },
        rounded: { borderRadius: SKELETON_TOKENS.radius },
        // 아바타 지름은 찌그러지면 안 되므로 여기만 축소 금지 (구 root flexShrink 의 실사용처)
        circular: { borderRadius: '50%', flexShrink: 0 },
        // animation prop 을 명시한 곳도 가이드 값으로 끌어옴
        pulse: skeletonPulse,
        // wave 는 가이드에 없음 — ::after 그라디언트 끄고 pulse 로 수렴
        wave: {
          ...skeletonPulse,
          '&::after': { display: 'none' },
        },
      },
    },
  };
}
